import { createSelector } from '@ngrx/store';
import { getDragonflyRedeemRulesState } from '../reducers';

export const getCreateNewState = createSelector(
  getDragonflyRedeemRulesState,
  (state) => state?.createNew,
);

export const getSidenavStatus = createSelector(getCreateNewState, (state) => state?.sidenavStatus);
export const getIsEdit = createSelector(getCreateNewState, (state) => state?.isEdit);
export const getEditRuleIndex = createSelector(getCreateNewState, (state) => state?.editRuleIndex);
export const getRedemptionTypes = createSelector(
  getCreateNewState,
  (state) => state?.redemptionTypes,
);
export const getMemberCategories = createSelector(
  getCreateNewState,
  (state) => state?.memberCategories,
);
export const getMemberStatuses = createSelector(
  getCreateNewState,
  (state) => state?.memberStatuses,
);
export const getMemberTags = createSelector(getCreateNewState, (state) => state?.memberTags);
export const getCurrencies = createSelector(getCreateNewState, (state) => state?.currencies);
export const getCouponSets = createSelector(getCreateNewState, (state) => state?.couponSets);
export const getBookCouponTemplates = createSelector(
  getCreateNewState,
  (state) => state?.bookCouponTemplates,
);
export const getSchemaCode = createSelector(getCreateNewState, (state) => state?.schemaCode);
export const getSchemaId = createSelector(getCreateNewState, (state) => state?.schemaId);
export const getRedemptionType = createSelector(
  getCreateNewState,
  (state) => state?.redemptionType,
);
export const getMemberCategoryCode = createSelector(
  getCreateNewState,
  (state) => state?.memberCategoryCode,
);
export const getMemberStatusCode = createSelector(
  getCreateNewState,
  (state) => state?.memberStatusCode,
);
export const getMemberTagCode = createSelector(getCreateNewState, (state) => state?.memberTagCode);
export const getPoints = createSelector(getCreateNewState, (state) => state?.points);
export const getAmount = createSelector(getCreateNewState, (state) => state?.amount);
export const getCurrency = createSelector(getCreateNewState, (state) => state?.currency);
export const getDiscount = createSelector(getCreateNewState, (state) => state?.discount);
export const getCouponSetCode = createSelector(getCreateNewState, (state) => state?.couponSetCode);
export const getBookCouponTemplateCode = createSelector(
  getCreateNewState,
  (state) => state?.bookCouponTemplateCode,
);
export const getMessage = createSelector(getCreateNewState, (state) => state?.message);
export const getSubmitted = createSelector(getCreateNewState, (state) => state?.submitted);
